// Lời gọi API "Phân tích Creator" (hp-media-server-staging/src/analytics/analytics.controller.ts).
// DTO backend bật forbidNonWhitelisted và groupId @Min(1): KHÔNG gửi tham số rỗng / không có trong DTO —
// toQuery bỏ null / undefined / ''. Lỗi nghiệp vụ là 409 (400 với tháng sai) `{ code, message }`, AxiosUtils
// ném nguyên `response.data` → nơi gọi phân nhánh theo `code` (format.ts errorCode / errorText).

import { API } from 'service/api-route';
import AxiosUtils from 'utils/axios-utils';
import type {
  AccessResponse,
  CreatorDetailResponse,
  CreatorKind,
  CreatorSort,
  CreatorsResponse,
  OverviewResponse,
  RecomputeResult,
} from './contract';

type QueryValue = string | number | null | undefined;

/** Bỏ giá trị rỗng (null / undefined / '' / NaN) để không gửi `groupId=` hay khoá lạ. */
export function toQuery(params: Record<string, QueryValue>): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value === null || value === undefined || value === '') return;
    if (typeof value === 'number' && !Number.isFinite(value)) return;
    out[key] = value;
  });
  return out;
}

// AxiosUtils trả nguyên response của axios (quy ước của dự án): dữ liệu nằm ở `.data`.
async function getJson<T>(url: string, params?: Record<string, QueryValue>): Promise<T> {
  const res: any = await AxiosUtils.get(url, params ? toQuery(params) : undefined);
  return res?.data as T;
}

export interface OverviewQuery {
  month?: string | null;
  groupId?: number | null;
  kind?: CreatorKind | null;
}

export interface CreatorsQuery extends OverviewQuery {
  sort?: CreatorSort | null;
  dir?: 'asc' | 'desc' | null;
  q?: string | null;
  page?: number | null;
  limit?: number | null;
}

export const getAccess = () => getJson<AccessResponse>(API.analyticsAccess);

export const getOverview = (q: OverviewQuery) =>
  getJson<OverviewResponse>(API.analyticsOverview, {
    month: q.month,
    groupId: q.groupId,
    kind: q.kind,
  });

export const getCreators = (q: CreatorsQuery) =>
  getJson<CreatorsResponse>(API.analyticsCreators, {
    month: q.month,
    groupId: q.groupId,
    kind: q.kind,
    sort: q.sort,
    dir: q.dir,
    q: q.q ? q.q.trim() : undefined,
    page: q.page,
    limit: q.limit,
  });

export const getCreator = (uid: string, month?: string | null) =>
  getJson<CreatorDetailResponse>(`${API.analyticsCreators}/${encodeURIComponent(uid)}`, {
    month,
  });

/** POST không có body; tháng đi trên query (MonthQueryDto). */
export async function postRecompute(month?: string | null): Promise<RecomputeResult> {
  const qs = month ? `?month=${encodeURIComponent(month)}` : '';
  const res: any = await AxiosUtils.post(`${API.analyticsRecompute}${qs}`);
  return res?.data as RecomputeResult;
}
